"use client"

import logger from "@/lib/logger/logger-init"
import { ResultFactory } from "@/types/generic/Result"

type ChangeShippingMethodResult = {
    success: boolean
    data?: any
    error?: Error
}

export const changeShippingMethod = async (formData: FormData) => {
    try {
        const response = await fetch("/api/centra/change-shipping-method", {
            method: "POST",
            credentials: "include",
            body: formData
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to change shipping method"
            logger.warn(errorMessage)
            return ResultFactory.failure<ChangeShippingMethodResult>(
                new Error(errorMessage)
            )
        }

        const successMessage = "Shipping method changed successfully"
        logger.info(successMessage, {
            data: result.data
        })
        return ResultFactory.success<ChangeShippingMethodResult>({
            success: true,
            data: result.data
        })
    } catch (error) {
        logger.error("Unexpected error in changeShippingMethod", error)
        return ResultFactory.failure<ChangeShippingMethodResult>(
            error instanceof Error ? error : new Error("An unknown error occurred")
        )
    }
}
